import React from "react";
import "./slideInModal.scss";
import { IoIosCloseCircle } from "react-icons/io";

const SlideInModal = ({ isOpen, onClose, children }) => {
  return (
    <div className={`slide-in-modal ${isOpen ? "open" : ""}`}>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content">
        <div className="btn_wrp">
          <button className="close-btn" onClick={onClose}>
            <IoIosCloseCircle size={20} color="gray" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default SlideInModal;
